import { render, staticRenderFns } from "./QLongReadonly.vue?vue&type=template&id=4704e734&scoped=true&"
import script from "./QLongReadonly.vue?vue&type=script&lang=js&"
export * from "./QLongReadonly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704e734",
  null
  
)

export default component.exports